import React from 'react';
import PropTypes from 'prop-types';

const AssessmentResult = props => {
  const { score } = props;
  const color = getColor(score);
  return (
    <div>
      <section className="quiz-results">
        <div className="container">
          <div className="row title">
            <div className="col-md-12">
              <h1>Your Results</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-md-offset-2">
              <div className={`score ${color}`}>
                <div className="score-number">
                  {score}<span className="score-percentage">%</span>
                </div>
                <div className="subtitle">GDPR ready</div>
              </div>
            </div>
            <div className="col-md-5">
              {color === 'green' &&
                <p className="score-message">
                  Well done! Your responses put you in the top 20% for GDPR readiness. We’re sending
                  you a detailed report that shows the areas in which you are well prepared, as well
                  as those that need extra attention. Please check your email for your personalized
                  assessment.
                </p>}
              {color === 'yellow' &&
                <p className="score-message">
                  Your answers put you at the {score}% level of readiness. This means you have some
                  areas well prepared and some that need attention. We're emailing you a detailed
                  report of the areas you are well prepared and those that may need additional
                  attention. Please check your email for the personalized report.
                </p>}
              {color === 'red' &&
                <p className="score-message">
                  Your answers put you at the {score}% level of readiness. This means you have quite
                  a few areas that need attention. But the good news is we're emailing you a
                  detailed report of the areas you should focus on for your GDPR preparation to help
                  with prioritization of tasks. Please check your email for the personalized report.
                </p>}
            </div>
          </div>
        </div>
      </section>
      <section className="quiz-results-footer theme-dark">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p className="cta-text">
                Would you like to set up a meeting with Auth0 to discuss the identity portions of
                your GDPR assessment?
              </p>
            </div>
            <div className="col-md-6">
              <a className="btn btn-lg btn-success" href="/gdpr-assessment/tool">Contact us</a>
              <a className="btn btn-lg btn-transparent" href="/" rel="external">
                Go to our homepage
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

AssessmentResult.propTypes = {
  score: PropTypes.number.isRequired
};

AssessmentResult.defaultProps = {};

export default AssessmentResult;

function getColor(score) {
  if (score < 45) {
    return 'red';
  }

  if (score < 80) {
    return 'yellow';
  }

  if (score >= 80) {
    return 'green';
  }

  return '';
}



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/AssessmentResult/AssessmentResult.js